<template>
  <Modal :show="true" centered size="fluid" title="Itinerario" @hide="$emit('hide')" body-class="p-0">
    <Spinner v-if="loading.view"></Spinner>
    <template v-else>
      <div class="card-body">
        <div class="row align-items-center">
          <div class="col-12 col-lg-9">
            <ul class="list-inline mb-0">
              <li class="list-inline-item"><strong>Código:</strong> {{ modalItem.codigo }}</li>
              <li class="list-inline-item"><strong>Agencia:</strong> {{ modalItem.agencia }}</li>
              <li class="list-inline-item"><strong>Doc. Venta:</strong> {{ modalItem.docVenta }}</li>
              <li class="list-inline-item"><strong>Fecha Llegada:</strong> {{ modalItem.fechaLlegada | date }}</li>
              <li class="list-inline-item"><strong>Fecha Salida:</strong> {{ modalItem.fechaSalida | date }}</li>
              <li class="list-inline-item"><strong>Idioma:</strong> {{ modalItem.idioma }}</li>
              <li class="list-inline-item"><strong>PAX:</strong> {{ modalItem.nroAdultos }}</li>
              <li class="list-inline-item" v-if="modalItem.nroNinos"><strong>CHD:</strong> {{ modalItem.nroNinos }}</li>
              <li class="list-inline-item"><strong>Nro. Doc. Venta:</strong> {{ modalItem.nroDocVenta }}</li>
              <li class="list-inline-item"><strong>Pasajero:</strong> {{ modalItem.pasajero }}</li>
            </ul>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group text-right">
              <button class="btn btn-sm btn-outline-secondary" @click="onPrint">
                Imprimir
              </button>
            </div>
          </div>
        </div>
      </div>
      <PrivadoItinerarioTable></PrivadoItinerarioTable>
    </template>
  </Modal>
</template>

<script>
import PrivadoItinerarioTable from "./PrivadoItinerarioTable.vue";
import Spinner from "../../shared/components/Spinner.vue";
import Modal from "../../shared/components/Modal.vue";
import { mapState } from "vuex";
import pdfPrivadoItinerario from "../../../pdfs/pdfPrivadoItinerario";

export default {
  components: { Modal, Spinner, PrivadoItinerarioTable },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    modalItem: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: {
        view: true,
        save: false,
      },
    };
  },
  async created() {
    let vm = this;
    await vm.fetchData(true);
    vm.loading.view = false;
  },
  computed: {
    ...mapState("privado.itinerario", ["list", "privado"]),
  },
  methods: {
    async fetchData(containers = false) {
      const vm = this;
      let response;

      try {
        response = await vm.axios.get(`/privados/${vm.modalItem.idPrivado}/itinerario`, {
          params: {
            containers: containers ? 1 : 0,
          },
        });
      } catch (err) {
        return;
      }

      const privadoItinerarioStore = {
        list: response.data.content.itinerary.map((item) => ({
          ...item,
          isNew: false,
          isEdit: false,
          tempFecha: "",
          tempServicio: "",
          tempProveedor: "",
          tempHotel: "",
          tempVueloTourTren: "",
          tempGuia: "",
          tempTipo: "",
          tempRestaurant: "",
          tempObservaciones: "",
        })),
      };

      if (containers) {
        privadoItinerarioStore.hoteles = response.data.content.hotels;
        privadoItinerarioStore.restaurantes = response.data.content.restaurants;
        privadoItinerarioStore.servicios = response.data.content.services.filter((item) => item.privado == 1);
        privadoItinerarioStore.serviciosTipos = response.data.content.servicesTypes;
        privadoItinerarioStore.vehiculos = response.data.content.vehiculos;
        privadoItinerarioStore.transfers = response.data.content.transfers;
        privadoItinerarioStore.proveedores = response.data.content.proveedores;
        privadoItinerarioStore.privado = vm.modalItem;

        vm.$store.commit("privado.itinerario/load", privadoItinerarioStore);
      } else {
        vm.$store.commit("privado.itinerario/updateList", privadoItinerarioStore.list);
      }
    },
    onPrint() {
      const vm = this;

      const itinerario = vm.list.map((item, index) => ({
        ...item,
        nro: index + 1,
        fecha: vm.$options.filters.date(item.fecha),
      }));

      const registro = {
        ...vm.privado,
        docVenta: vm.privado.docVenta || "",
        fechaLlegada: vm.$options.filters.date(vm.privado.fechaLlegada),
        fechaSalida: vm.$options.filters.date(vm.privado.fechaSalida),
      };

      pdfPrivadoItinerario({
        itinerario,
        registro,
        userMark: vm.$store.state.user,
        dateMark: vm.$dayjs().format("DD-MM-YY HH:mm"),
      });
    },
  },
};
</script>
